import React from 'react';

import { UserModel, userModelInitial } from '../../Models/UserModel';

export interface IUserContextProps {
    user: UserModel,
    setUser: (user: UserModel) => void,
    userList: UserModel[],
    setUserList: (users: UserModel[]) => void,
}

export const userContextInitial: IUserContextProps = {
    user: userModelInitial,
    setUser: () => { ''; },
    userList: [],
    setUserList: () => { ''; },
};

export const UserContext = React.createContext(userContextInitial);